// @ts-nocheck

import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component, PureComponent, Fragment, useState } from "react";

import { useTransition, animated } from "react-spring";

import * as styles from "./Button.Loader.styles";



const Loader = ({ loading, style: externalStyles }) => {

  const transitions = useTransition(loading ? [ true ] : [], item => item.key, {
    config: {
      mass: 0.1,
      friction: 12
    },
    from: {
      transform: "translate3d(20px,0,0)",
      width: 0,
      marginLeft: 0
    },
    enter: {
      transform: "translate3d(0,0px,0)",
      width: 20,
      opacity: 1,
      marginLeft: 5
    },
    leave: {
      transform: "translate3d(40px,0,0)",
      width: 0,
      opacity: 0,
      marginLeft: 0
    }
  });

  return transitions.map(({ item, props, key }) =>
    <animated.div
      key={key}
      css={[
        styles.animatedCss,
        externalStyles
      ]}
      style={props}>
      <span css={styles.loaderCss}>
        <svg version="1.1" x="0px" y="0px"
          viewBox="0 0 512 512" xmlSpace="preserve">
          <g>
            <path d="M370.9,196.7l68.8,68.8l68.8-68.8L485.9,174l-30,30c-11.4-46.2-38.4-87-76.3-115.7C288,19.1,157.7,37.2,88.5,128.7L114,148 c22.4-29.5,53.4-51.2,88.9-62c92.9-28.4,191.2,24,219.5,116.9L393.6,174L370.9,196.7z" />
            <path d="M0,311.5l22.7,22.6l30-29.9c22.8,92.8,105.9,158,201.4,158c11.3,0,22.6-0.9,33.8-2.7c54.5-8.8,103.2-39,135.2-83.8 l-26-18.7c-22.6,31.4-54.9,54.4-91.9,65.6C212.2,450.7,113.9,398.1,85.8,305l29.1,29.1l22.6-22.6l-68.8-68.8L0,311.5z M67.6,289.2 l1.2-1.2l0.8,0.8L67.6,289.2z" />
          </g>
        </svg>
      </span>
    </animated.div>
  );
};

Loader.propTypes = {
  loading: PropTypes.bool
};

export default Loader;
